export default {
  es: {
    dashboard: 'Dashboard',
    myDashboard: 'Mi tablero',
    patients: 'Gestión de pacientes',
    registerPatients: 'Registros de pacientes',
    roles: 'Roles',
    paramSystem: 'Parámetros del sistema',
    paramMedical: 'Parámetros médicos',
    users: 'Usuarios',
    profiles: 'Perfiles',
    item1: 'Componentes 1',
    options: 'Opciones',
    logout: 'Cerrar Sesión',
    english: 'Inglés',
    spanish: 'Español',
    nephroprotection: 'Nefroplus Renal Care Services',
    educationalMaterial: 'Material educativo',
    Categories: 'Categorías',
    Category: 'Categoría',
    Element: 'Elemento',
    uploadMaterial: 'Cargar material',
    editMaterial: 'Editar material',
    ITakeCare: 'Aprendo a cuidarme',
    videoCalls: 'Videollamada',
    // OTHER MENU STRINGS
    myLabs: 'Mis laboratorios',
    appointsCalendar: 'Citas y calendario',
    reports: 'Reportes',
    params: 'Parámetros',
    clinicHistory: 'Historia clínica',
    myStatus: 'Mi estado',
    stage: 'Estadío',
    bloodPressure: 'Tensión arterial',
    glucometry: 'Glucometría',
    bloodGlucose: 'Glicemia',
    myMetrics: 'Mis métricas',
    nutritionalClass: 'Clas. Nutricional',
    adherence: 'Adherencia',
    myVisits: 'Mis visitas',
    appointments: 'Citas',
    myAppointments: 'Mis citas',
    outpatientControl: 'Control ambulatorio',
    exams: 'Exámenes',
    scheduledAppoint: 'Citas agendadas',
    contact: 'Contactar',
    myProfile: 'Mi perfil',
    about: 'Acerca de...',
    help: 'Ayuda',
    risk: 'Riesgo',
    vaccinationSts: 'Estado de vacunación',
    renalProgress: 'Progresión renal',
    access: 'Accesos',
    proteinWear: 'Desgaste proteico',
    nutritionalInd: 'Indicador nutricional',
    education: 'Educación',
    preservedHand: 'Manejo conservador',
    psychosocialProf: 'Pefil psicosocial',
    psychologicalEval: 'Valoración psicológica',
    events: 'Eventos',
    myEvents: 'Mis eventos',
    clinicParams: 'Parámetros clínicos',
    metabolicDiab: 'Metabólico diabetes',
    status: 'Estado de servicios',
    calendar: 'Calendario',
    schedule: 'Agendar cita',
    confirmDate: 'Confirmar cita',
    reschedule: 'Reagendar cita',
    riskClasification: 'Clasificación del riesgo',
    nephroPlusChat: 'Nefroplus chat',
    aboutApp: 'Acerca de',
    termsAndConditions: 'Términos y condiciones',
    patientDetailed: 'Información detallada de pacientes',
    indicator: 'Indicador',
    detailedInformation: 'Información detallada',
    myStage: 'Mi estadío actual',
    myRecords: 'Mis registros',
    records: 'Registros',
    myRecommendations: 'Mis recomendaciones'
  },
  en: {
    dashboard: 'Dashboard',
    myDashboard: 'My dashboard',
    patients: 'Patient management',
    registerPatients: 'Patients records',
    roles: 'Roles',
    paramSystem: 'System parameters',
    paramMedical: 'Medical parameters',
    users: 'Users',
    profiles: 'Profiles',
    item1: 'Components',
    options: 'Options',
    logout: 'Logout',
    english: 'English',
    spanish: 'Spanish',
    nephroprotection: 'Nefroplus Renal Care Services',
    educationalMaterial: 'Educational material',
    ITakeCare: 'I learned to take care of myself',
    Categories: 'Categories',
    Category: 'Category',
    Element: 'Element',
    uploadMaterial: 'Upload material',
    editMaterial: 'Edit material',
    videoCalls: 'Videocalls',
    // OTHER MENU STRINGS
    myLabs: 'My labs',
    appointsCalendar: 'Appointments and calendar',
    reports: 'Reports',
    params: 'Params',
    clinicHistory: 'Clinic history',
    myStatus: 'My Status',
    stage: 'Stage',
    bloodPressure: 'Blood pressure',
    glucometry: 'Glucometry',
    bloodGlucose: 'Blood glucose',
    myMetrics: 'My metrics',
    nutritionalClass: 'Nutritional Class.',
    adherence: 'Adherence',
    myVisits: 'My visits',
    appointments: 'Appointments',
    myAppointments: 'My appointments',
    outpatientControl: 'Ambulatory control',
    exams: 'Exams',
    scheduledAppoint: 'Scheduled appointments',
    contact: 'Contact',
    myProfile: 'My profile',
    about: 'About...',
    help: 'Help',
    risk: 'Risk',
    vaccinationSts: 'Vaccination status',
    renalProgress: 'Kidney progress',
    access: 'Access',
    proteinWear: 'Protein wear',
    nutritionalInd: 'Nutritional indicator',
    education: 'Education',
    preservedHand: 'Preserved handling',
    psychosocialProf: 'Psychosocial profile',
    psychologicalEval: 'Psychological evaluation',
    events: 'Events',
    myEvents: 'My events',
    clinicParams: 'Clinic params',
    metabolicDiab: 'Metabolic diabetes',
    status: 'Services status',
    calendar: 'Calendar',
    schedule: 'Schedule appointment',
    confirmDate: 'Confirm appointment',
    reschedule: 'Reschedule appointment',
    riskClasification: 'Risk classification',
    nephroPlusChat: 'Nefroplus chat',
    aboutApp: 'About',
    termsAndConditions: 'Terms and conditions',
    patientDetailed: 'Patients detailed information',
    indicator: 'Indicator',
    detailedInformation: 'Detailed information',
    myStage: 'My current stage',
    myRecords: 'My records',
    records: 'Records',
    myRecommendations: 'My recommendations'
  }
};
